<header id="header" class="fullHeight">
  <div class="container text-center fullHeight">
    <div class="row d-flex align-items-center justify-content-end" style="height: 100%;">



      <!-- inline styles for future super admin control -->
      <div class="lLeft col-md-6" [style.background-image]="loginPhoto">
        <div class="overlay" [style.background]="loginColor" [style.opacity]="loginOverlay">
        </div>
      </div>

      <div class="lRight col-md-6">
        <div class="logo">
          <img src="../../assets/images/logo/logo-blue-circle.svg" alt="Indy Chamber Logo" />
        </div>

        <!-- Login -->
        <div id="login" *ngIf="displayState == 0">
          <div class="loginMessage">
            <div class="messageHeader">Member Login</div>
            <div class="messageText" hidden>Login to your account</div>
          </div>
          <form [formGroup]="loginForm" (keyup.enter)="login()">
            <fieldset class="form-group">
              <div class="form-floating">
                <input type="text" class="form-control form-control-lg" formControlName="userName" autofocus placeholder="" />
                <label><i class="fa-regular fa-envelope me-1"></i> Email Address</label>
              </div>
            </fieldset>
            <fieldset class="form-group mt-3">
              <div class="form-floating">
                <input type="password" class="form-control form-control-lg" id="password" placeholder=""
             formControlName="password" autocomplete="off" />
                <label><i class="fa-regular fa-lock me-1"></i> Password</label>
              </div>
            </fieldset>
            <fieldset class="mt-4">
              <button type="button" [disabled]="loginForm.invalid || isBusy" (click)="login()" class="btn btn-lg btn-block login-btn w-100 mb-2">Sign In</button>
              <button type="button" [routerLink]="['/admin-portal/sign-up/general']" class="btn btn-lg btn-block login-btn-drop w-100">Become a Member</button>
              <div class="text-center mt-3">
                <a class="text-link-blue" id="forgot-password-link" (click)="displayState = 1" href="javascript:void(0)"><small>forgot your password?</small></a>
              </div>
              <div class="text-center mt-3">
                <a class="text-link-blue" id="tos" href="https://IndyChamber.com/termsofservice" target="_blank"><small>Terms and Conditions </small></a>
                <br>
                <a class="text-link-blue" id="pp" href="https://IndyChamber.com/privacypolicy" target="_blank"><small>Privacy Policy</small></a>
              </div>
            </fieldset>
          </form>
        </div>


        <!-- Reset Password -->
        <div id="reset-password" *ngIf="displayState == 1">
          <div class="loginMessage">
            <div class="messageHeader">Reset Password</div>
            <div class="messageText">
              Forgot your password? No worries! Enter your email address below, and we'll send you a link to reset your password. Check your inbox and follow the instructions. If you don't receive the email within a few minutes, please check your spam folder.
            </div>
          </div>
          <form [formGroup]="resetForm" (keyup.enter)="forgotPassword()">
            <fieldset class="form-group">
              <div class="form-floating">
                <input type="text" class="form-control form-control-lg" placeholder="" formControlName="userName" autofocus />
                <label><i class="fa-regular fa-envelope me-1"></i> Email Address</label>
              </div>
            </fieldset>
            <fieldset class="mt-4">
              <button (click)="forgotPassword()" type="button" class="btn btn-lg btn-block login-btn w-100">
                Send Reset
                Link
              </button>
            </fieldset>
          </form>
          <div class="login-links mt-3">
            <a class="text-link-blue" (click)="displayState = 0" id="login-back-link" href="javascript:void(0)">
              <i class="far fa-arrow-left"></i> back to
              login
            </a>
          </div>
        </div>


        <!-- New Password -->
        <!--<div id="new-password" class="hide">
          <div class="loginMessage">
            <div class="messageHeader">Create New Password</div>
            <div class="messageText">Enter a new password</div>
          </div>
          <form>
            <fieldset class="form-group">
              <div class="form-floating">
                <input type="password" class="form-control form-control-lg" placeholder="Password" required>
                <label><i class="fa-regular fa-lock me-1"></i> New Password</label>
              </div>
            </fieldset>
            <fieldset class="form-group mt-3">
              <div class="form-floating">
                <input type="password" class="form-control form-control-lg" placeholder="Confirm Password" required>
                <label><i class="fa-regular fa-lock me-1"></i> Confirm New Password</label>
              </div>
            </fieldset>
            <fieldset class="mt-4">
              <button type="button" class="btn btn-lg btn-block login-btn w-100">Save New Password</button>
            </fieldset>
          </form>
          <div class="login-links mt-3">
            <a class="text-link-blue" id="login-back-link" href="#">
              <i class="far fa-arrow-left"></i> back to
              login
            </a>
          </div>
        </div>-->



      </div>

    </div>



  </div>
</header>


<!-- Footer-->
<footer hidden class=" py-2 bg-light">
  <div class="container px-4"><p class="m-0 text-center text-dark">Copyright &copy; Indy Chamber 2024</p></div>
</footer>
